import { render, staticRenderFns } from "./BatimentActions.vue?vue&type=template&id=5fb41dc0&scoped=true&"
import script from "./BatimentActions.vue?vue&type=script&lang=js&"
export * from "./BatimentActions.vue?vue&type=script&lang=js&"
import style0 from "./BatimentActions.vue?vue&type=style&index=0&id=5fb41dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb41dc0",
  null
  
)

export default component.exports